import { Outlet } from "react-router-dom";
import DashboardSidenav from "./SideBar";

import NavBar from "./NavBar";
import { useLayoutEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { routesToHideFilter, routesToHidNavBar } from "../utils/utils";
import { PAGE_PADDING, ROLE } from "../utils/constants";
import GeneralLayout from "./GeneralLayout";
import { selectAuthSlice } from "../store/authSlice";
import { useAppSelector } from "../store/hooks";
import { useSidebar } from "../customHooks/useSidebar";

function DashboardLayout() {
  const { user } = useAppSelector(selectAuthSlice);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const location = useLocation();
  const isNavBarHidden = routesToHidNavBar(
    user?.company_id || (user?.company.id as string)
  ).includes(location.pathname);
  const showDateFilter = routesToHideFilter(
    user?.company_id || (user?.company.id as string)
  ).includes(location.pathname);
  // const showSearch = routesToShowSearch.includes(location.pathname);
  const toggleNav = () => setIsSidebarOpen(!isSidebarOpen);
  const items = useSidebar(
    user?.access_level as ROLE,
    user?.company?.id as string
  );
  const navRef = useRef<HTMLDivElement>(null);
  // const sideBarRef = useRef<HTMLDivElement>(null);

  // const [sideBarWidth, setSidebarWidth] = useState(0);

  // useLayoutEffect(() => {
  //   if (sideBarRef.current) {
  //     setSidebarWidth(sideBarRef.current.offsetWidth);
  //   }
  //   const resizeObserver = new ResizeObserver(() => {
  //     if (sideBarRef.current) setSidebarWidth(sideBarRef.current.offsetWidth);
  //   });
  //   if (sideBarRef.current) resizeObserver.observe(sideBarRef.current);
  //   return () => resizeObserver.disconnect();
  // }, []);

  const [navHeight, setNavHeight] = useState(0);
  // Update navHeight on mount and when the navRef changes
  useLayoutEffect(() => {
    if (navRef.current) {
      setNavHeight(navRef.current.offsetHeight);
    }
    const resizeObserver = new ResizeObserver(() => {
      if (navRef.current) setNavHeight(navRef.current.offsetHeight);
    });
    if (navRef.current) resizeObserver.observe(navRef.current);
    return () => resizeObserver.disconnect();
  }, []);
  // Update isSidebarOpen based on window width
  useLayoutEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth >= 768);
      // setSidebarWidth(sideBarRef.current?.offsetWidth || 0);
    };

    handleResize(); // on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <GeneralLayout>
      <div className="h-full">
        <DashboardSidenav
          items={items}
          isOpen={isSidebarOpen}
          toggleNav={toggleNav}
        />
        {/* Fixed top NavBar wrapper */}
        {!isNavBarHidden && (
          <div
            className={`fixed top-0 right-0 z-40 flex justify-center bg-inherit ${
              isSidebarOpen ? "left-[15rem]" : "left-20"
            }`}
          >
            <div ref={navRef} className="w-full max-w-[calc(2000px_-_15rem)]">
              <NavBar
                showDateFilter={!showDateFilter}
                isSidebarOpen={isSidebarOpen}
              />
            </div>
          </div>
        )}
        <div
          className={`${
            isSidebarOpen ? "ml-60" : "ml-20"
          } flex flex-col items-center justify-center bg-white min-h-full`}
          style={{ padding: PAGE_PADDING }}
        >
          <div
            className="w-full h-full min-h-[100vh]"
            style={{ marginTop: `${navHeight}px` }}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </GeneralLayout>
  );
}

export default DashboardLayout;
